import React from 'react';
import styled from 'styled-components';
import { Spinner } from './Spinner';
export const StyledOverlay = styled.div.withConfig({
  displayName: "SpinnerOverlay__StyledOverlay",
  componentId: "sc-9bkq15-0"
})(["background-color:rgba(255,255,255,0.75);position:absolute;top:0;left:0;right:0;bottom:0;z-index:", ";> *{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}"], x => x.theme.z.super);
export const SpinnerOverlay = () => /*#__PURE__*/React.createElement(StyledOverlay, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, null)));